export default __webpack_public_path__ + "static/media/6.2da1a4f1.png";